import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

class RichSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value,
      isOpen: false,
    }
    this.onChange = this.onChange.bind(this)
    this.toggle = this.toggle.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  handleClickOutside(event) {
    if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
      this.setState({ isOpen: false })
    }
  }

  toggle() {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }))
  }

  onChange(event) {
    if (this.props.comingFromMapView) {
      Amplitude.trackEvent("reservation_labels:map_view_select")
    }
    const value = event.currentTarget.attributes[0].value
    this.setState({ value, isOpen: false })
    this.props.onChange({
      target: {
        value,
        name: this.props.name,
      },
    })
  }

  render() {
    const selectedOption = this.props.options.find(
      (option) =>
        option.id === this.state.value ||
        option.id === parseInt(this.state.value, 10)
    )

    // Handle case when selectedOption is undefined (value doesn't match any option or options array is empty)
    const displayContent = selectedOption?.content || (
      <span className="text-muted">Select an option</span>
    )

    return (
      <div className="btn-group" ref={(ref) => (this.dropdownRef = ref)}>
        <button
          className="btn dropdown-toggle"
          type="button"
          onClick={this.toggle}
          aria-haspopup="true"
          aria-expanded={this.state.isOpen}
          disabled={this.props.options.length === 0}
        >
          <span className="flex">
            {displayContent}
            <span className="caret ml-1 mt-2" />
          </span>
        </button>
        <ul
          className={classNames("dropdown-menu", {
            [this.props.dropdownMenuClasses]: this.props.dropdownMenuClasses,
            show: this.state.isOpen,
          })}
          style={{ display: this.state.isOpen ? "block" : "none" }}
        >
          {this.props.options.map((option) => (
            <li key={option.id} className="cursor-pointer">
              <a value={option.id} onClick={this.onChange}>
                {option.content}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

RichSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  dropdownMenuClasses: PropTypes.string,
  comingFromMapView: PropTypes.bool,
}

export default RichSelect
